import React from "react";
import styles from "./style.module.css";
import AlertCard from "components/MonitoringMobile/AlertCard";
import chevronRightImg from "aible/images/chevron-right.svg";

const cards = [
  {
    title: "Loading Data, please stand by",
    visualData: "Pending",
    details: "",
    recommend: ""
  }
];

export default class AlertCardGroup extends React.Component {
  getRecentSegment(latestData) {
    //grab the most recent segment. We base segment recency based on its highest segment id
    //We will need a better heuristic for ID recent segment ID in the future, or possibly scrap the notion.

    let keys = Object.keys(latestData);
    keys = keys.map((k) => parseInt(k, 10));
    return Math.max(...keys);
  }

  //prep our warning data here
  prepCards() {
    const { warningsGroup, monitor } = this.props;
    let retcards = [];
    //currently, all warnings have a transaction and conversion rate.
    //I'll get the latest segment. If data is NaN, i'll map it as a zero
    //I'll use warning.type to distinguish between the two

    //monitors latestDatas must be collected
    let latestData = monitor.map((m) => m.latestData);
    let idx = 0;
    for (let warnings of warningsGroup) {
      if (warnings) {
        //use the last segment for data
        let recentSegment = this.getRecentSegment(latestData[idx]);
        for (let warning of warnings) {
          let barData = {};
          if (recentSegment) {
            if (warning.type == "Transaction Rate") {
              barData = {
                assumed: latestData[idx][recentSegment]["countAssumed"],
                actual: latestData[idx][recentSegment]["count"],
                percentage: false
              };
            } else {
              barData = {
                assumed: latestData[idx][recentSegment]["assumedConversionRate"],
                actual: latestData[idx][recentSegment]["conversionRate"],
                percentage: true
              };
            }
          }
          warning &&
            retcards.push({
              title: `${warning.type} is Lower than Expected`,
              visualData: "Pending",
              details: `You're ${(warning.time * 100).toPrecision(4)}% of the way into the time period and you
									  have ${Math.abs((warning.value * 100).toPrecision(4))}% fewer ${warning.type} than expected.`,
              recommend:
                "Aible recommends adjusting the expected Transaction Rate to have more accurate business predictions.",
              barData: barData
            });
        }
        idx += 1;
      }
    }

    return retcards;
  }

  render() {
    const warningCards = this.prepCards();
    const cardGroupHeight = window.innerHeight - 197 - 60 - 35 - 103 + 28 + "px";

    return (
      <div className={styles.cardGroupHolder} style={{ height: cardGroupHeight }}>
        <div className={styles.cardSlider}>
          <img className={styles.chevron + " " + styles.flipped} src={chevronRightImg} alt={chevronRightImg} />
          {
            warningCards.length
              ? warningCards.map((card, i) => {
                  // return(<AlertCard num={i+1} total={warningCards.length} data={card}/>)
                  return <AlertCard num={i + 1} total={warningCards.length} card={card} />;
                })
              : ""
            // <AlertCard num={1} total={cards.length} card={cards[0]}/>
          }
        </div>
      </div>
    );
  }
}
